import { getPropertyTitle } from '../App.hooks';
export const REACT_SELECT_CLASSNAMES = {
	placeholder: () => {
		return 'placeholder';
	},
};
export const PAGINATION_COMPONENT_OPTIONS = {
	rowsPerPageText: 'Filas por página',
	rangeSeparatorText: 'de',
	selectAllRowsItem: true,
	selectAllRowsItemText: 'Todos',
};

export const FILTER_INITIAL_DATA = {
	plan: null,
	block: null,
	street: null,
	avenue: null,
	estate: null,
	property: null,
	lot: null,
	type: null,
	owner: null,
	condition: null,
	area: null,
	range: null,
	certification: null,
	areaCode: null,
	corrections: null,
};

export const DATA_TABLE_CUSTOM_STYLES = {
	cells: {
		style: {
			maxWidth: 100,
			paddingLeft: '10px', // override the cell padding for data cells
			paddingRight: '0px',
		},
	},
};

export const COLUMNS = [
	{
		name: getPropertyTitle('id'),
		selector: (row) => row['id'],
		sortable: true,
	},
	{
		name: getPropertyTitle('plan'),
		selector: (row) => row['plan'],
		sortable: true,
	},
	{
		name: getPropertyTitle('block'),
		selector: (row) => row['block'],
		sortable: true,
	},
	{
		name: getPropertyTitle('street'),
		selector: (row) => row['street'],
		sortable: true,
	},
	{
		name: getPropertyTitle('avenue'),
		selector: (row) => row['avenue'],
		sortable: true,
	},
	{
		name: getPropertyTitle('lot'),
		selector: (row) => row['lot'],
		sortable: true,
	},
	{
		name: getPropertyTitle('corrections'),
		selector: (row) => row['corrections'],
		sortable: true,
	},
];
